(function () {
  'use strict';

  var LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  var NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search';
  var GERMANY_CENTER = [50.5, 10.0];
  var DEFAULT_ZOOM = 6;

  function loadCSS(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      document.head.appendChild(link);
    });
  }

  function loadJS(src) {
    if (window.L) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function geocode(address) {
    var url = NOMINATIM_URL + '?format=json&q=' + encodeURIComponent(address) + '&limit=1';
    return fetch(url, {
      headers: { 'User-Agent': 'ZwoelberichStoreLocator/1.0' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.length > 0) {
          return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function createMarkerIcon() {
    return L.divIcon({
      className: 'store-locator-marker',
      html: '<svg width="28" height="40" viewBox="0 0 28 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M14 0C6.268 0 0 6.268 0 14c0 10.5 14 26 14 26s14-15.5 14-26C28 6.268 21.732 0 14 0z" fill="#8B2635"/>' +
        '<circle cx="14" cy="14" r="6" fill="#fff"/>' +
        '</svg>',
      iconSize: [28, 40],
      iconAnchor: [14, 40],
      popupAnchor: [0, -36]
    });
  }

  function buildPopupContent(partner) {
    var html = '<div class="store-locator__popup">';
    if (partner.type) {
      html += '<div class="store-locator__popup-type">' + escapeHtml(partner.type) + '</div>';
    }
    html += '<div class="store-locator__popup-name">' + escapeHtml(partner.name) + '</div>';
    html += '<div class="store-locator__popup-address">';
    html += escapeHtml(partner.street);
    if (partner.house_number) html += ' ' + escapeHtml(partner.house_number);
    html += '<br>' + escapeHtml(partner.postal_code) + ' ' + escapeHtml(partner.city);
    html += '</div>';
    html += '<div class="store-locator__popup-links">';
    if (partner.phone) {
      html += '<a href="tel:' + escapeHtml(partner.phone) + '">' + escapeHtml(partner.phone) + '</a>';
    }
    if (partner.website) {
      html += '<a href="' + escapeHtml(partner.website) + '" target="_blank" rel="noopener">Webseite</a>';
    }
    html += '</div></div>';
    return html;
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function initStoreLocator(sectionEl) {
    var sectionId = sectionEl.dataset.sectionId;
    var mapContainer = sectionEl.querySelector('.store-locator__map');
    var listContainer = sectionEl.querySelector('.store-locator__list');
    var dataEl = document.getElementById('store-locator-data-' + sectionId);

    if (!mapContainer || !dataEl) return;

    var partners;
    try {
      partners = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    if (!partners || partners.length === 0) return;

    Promise.all([loadCSS(LEAFLET_CSS), loadJS(LEAFLET_JS)])
      .then(function () {
        return loadJS(LEAFLET_JS);
      })
      .then(function () {
        buildMap(mapContainer, listContainer, partners, sectionId, sectionEl);
      });
  }

  function buildMap(mapContainer, listContainer, partners, sectionId, sectionEl) {
    // Clear any existing map instance
    if (mapContainer._leafletMap) {
      mapContainer._leafletMap.remove();
    }

    var map = L.map(mapContainer, {
      scrollWheelZoom: false,
      zoomControl: true
    }).setView(GERMANY_CENTER, DEFAULT_ZOOM);

    mapContainer._leafletMap = map;

    // OpenStreetMap standard tiles: no API key. CARTO basemaps now return an
    // "API KEY REQUIRED" watermark tile for keyless requests (2026-10).
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(map);

    var markerIcon = createMarkerIcon();
    var markers = [];
    var markerMap = {}; // index -> marker
    var geocodeQueue = [];

    partners.forEach(function (partner, index) {
      var lat = parseFloat(partner.lat);
      var lng = parseFloat(partner.lng);

      if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
        var marker = addMarker(map, partner, lat, lng, markerIcon, markers, index, listContainer);
        markerMap[index] = marker;
      } else {
        geocodeQueue.push({ partner: partner, index: index });
      }
    });

    // Store markerMap on the container for filter access
    mapContainer._markerMap = markerMap;
    mapContainer._allMarkers = markers;

    // Fit bounds to markers if we have any
    if (markers.length > 0) {
      fitBounds(map, markers);
    }

    // Process geocode queue with rate limiting
    if (geocodeQueue.length > 0) {
      processGeocodeQueue(geocodeQueue, map, markerIcon, markers, markerMap, listContainer);
    }

    // Enable scroll zoom after first interaction
    map.once('click', function () {
      map.scrollWheelZoom.enable();
    });

    // Set up search and filter
    initFilters(sectionEl, mapContainer, listContainer, partners);
  }

  function initFilters(sectionEl, mapContainer, listContainer, partners) {
    var searchInput = sectionEl.querySelector('.store-locator__search');
    var filterBtns = sectionEl.querySelectorAll('.store-locator__filter-btn');
    var noResults = listContainer.querySelector('.store-locator__no-results');
    var activeType = '';
    var searchTerm = '';
    var debounceTimer;

    function applyFilters() {
      var map = mapContainer._leafletMap;
      var markerMap = mapContainer._markerMap || {};
      var visibleMarkers = [];
      var visibleCount = 0;

      var items = listContainer.querySelectorAll('.store-locator__item');
      items.forEach(function (item) {
        var index = parseInt(item.dataset.partnerIndex);
        var type = item.dataset.partnerType || '';
        var name = item.dataset.partnerName || '';
        var city = item.dataset.partnerCity || '';
        var street = item.dataset.partnerStreet || '';

        var matchesType = !activeType || type === activeType;
        var matchesSearch = !searchTerm ||
          name.indexOf(searchTerm) !== -1 ||
          city.indexOf(searchTerm) !== -1 ||
          street.indexOf(searchTerm) !== -1;

        var visible = matchesType && matchesSearch;

        if (visible) {
          item.classList.remove('store-locator__item--hidden');
          visibleCount++;
          if (markerMap[index]) {
            if (!map.hasLayer(markerMap[index])) {
              markerMap[index].addTo(map);
            }
            visibleMarkers.push(markerMap[index]);
          }
        } else {
          item.classList.add('store-locator__item--hidden');
          if (markerMap[index] && map.hasLayer(markerMap[index])) {
            map.removeLayer(markerMap[index]);
          }
        }
      });

      // Show/hide no results
      if (noResults) {
        noResults.style.display = visibleCount === 0 ? '' : 'none';
      }

      // Refit bounds
      if (visibleMarkers.length > 0) {
        fitBounds(map, visibleMarkers);
      } else if (visibleCount === 0) {
        map.setView(GERMANY_CENTER, DEFAULT_ZOOM);
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          searchTerm = searchInput.value.toLowerCase().trim();
          applyFilters();
        }, 200);
      });
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('store-locator__filter-btn--active'); });
        btn.classList.add('store-locator__filter-btn--active');
        activeType = btn.dataset.filterType || '';
        applyFilters();
      });
    });
  }

  function addMarker(map, partner, lat, lng, icon, markers, index, listContainer) {
    var marker = L.marker([lat, lng], { icon: icon })
      .addTo(map)
      .bindPopup(buildPopupContent(partner), { maxWidth: 260, autoPan: false });

    marker._partnerIndex = index;
    markers.push(marker);

    // Marker click highlights list item
    marker.on('click', function () {
      highlightListItem(listContainer, index);
    });

    // List item click
    var listItem = listContainer ? listContainer.querySelector('[data-partner-index="' + index + '"]') : null;
    if (listItem) {
      listItem.addEventListener('click', function () {
        map.setView([lat, lng], 14, { animate: true });
        setTimeout(function () { marker.openPopup(); }, 300);
        highlightListItem(listContainer, index);
        // Scroll map into view on mobile
        if (window.innerWidth < 750) {
          map.getContainer().scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    return marker;
  }

  function highlightListItem(listContainer, index) {
    if (!listContainer) return;
    var items = listContainer.querySelectorAll('.store-locator__item');
    items.forEach(function (item) {
      item.classList.remove('store-locator__item--active');
    });
    var activeItem = listContainer.querySelector('[data-partner-index="' + index + '"]');
    if (activeItem) {
      activeItem.classList.add('store-locator__item--active');
      activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function fitBounds(map, markers) {
    if (markers.length === 0) return;
    var group = L.featureGroup(markers);
    map.fitBounds(group.getBounds().pad(0.1));
  }

  function processGeocodeQueue(queue, map, icon, markers, markerMap, listContainer) {
    var i = 0;
    function next() {
      if (i >= queue.length) {
        fitBounds(map, markers);
        return;
      }
      var item = queue[i];
      var address = (item.partner.street || '') + ' ' + (item.partner.house_number || '') +
        ', ' + (item.partner.postal_code || '') + ' ' + (item.partner.city || '') + ', Deutschland';
      geocode(address).then(function (coords) {
        if (coords) {
          var marker = addMarker(map, item.partner, coords.lat, coords.lng, icon, markers, item.index, listContainer);
          markerMap[item.index] = marker;
          fitBounds(map, markers);
        }
        i++;
        delay(1100).then(next);
      });
    }
    next();
  }

  // Initialize on DOM ready
  function init() {
    var sections = document.querySelectorAll('[data-store-locator]');
    sections.forEach(initStoreLocator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor events
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-store-locator]');
    if (section) initStoreLocator(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var sectionEl = event.target.closest('[data-store-locator]');
    if (!sectionEl) return;
    var mapContainer = sectionEl.querySelector('.store-locator__map');
    if (!mapContainer || !mapContainer._leafletMap) return;

    var index = event.target.dataset.partnerIndex;
    if (index === undefined) return;

    var map = mapContainer._leafletMap;
    map.eachLayer(function (layer) {
      if (layer._partnerIndex !== undefined && layer._partnerIndex === parseInt(index)) {
        var latlng = layer.getLatLng();
        map.setView(latlng, 14, { animate: true });
        setTimeout(function () { layer.openPopup(); }, 300);
      }
    });

    highlightListItem(sectionEl.querySelector('.store-locator__list'), parseInt(index));
  });
})();
